import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles({
    container: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        background: 'linear-gradient(160deg, #0d2a5a 0%, #134187 50%, #1b2d45 100%)',
    },
    boxWelcome: {
        display: 'flex',
        justifyContent: 'center',
        padding: '32px',
        paddingBottom: 16,
    },
    welcomeContainer: {
        display: 'flex',
        width: '70%',
        flexDirection: 'column',
    },
    boxCard: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        padding: 32,
        paddingTop: 64,
        gap: 24,
        background: '#F5F7FA',
        borderTopRightRadius: 100,
        boxShadow: '0 6px 32px rgba(0, 0, 0, 0.5)'

    },
    cardContainer: {
        display: 'grid',
        gap: 24,
        gridAutoRows: '1fr',
        justifyContent: 'space-between',
        gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))',
    },
    cardContent: {
        display: 'flex',
        alignItems: 'center',
        gap: 16,
        flex: 1,
        borderBottomRightRadius: 48,
        padding: '12px 16px'
    },
    card: {
        display: 'flex',
        flexDirection: 'row',
        gap: 16,
        borderRadius: 8,
        border: 'solid 1px #EEE',
        height: '100%',
        alignItems: 'flex-start',
        background: '#FFF',
        width: '100%'
    },
    iconContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 54,
        height: 54,
        borderRadius: '100%'
    },
    contentText: {
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        flex: 1
    },
    cardTitle: {
        fontSize: 18,
        fontWeight: 700
    },
    cardDescription: {
        fontSize: 14,
        fontWeight: 400
    },
    space: {
        gap: 16,
        display: 'flex',
        flexDirection: 'column'
    },
    flex: {
        display: 'flex',
        gap: 4,
        alignItems: 'center'
    },
    textHighlight: {
        fontWeight: 700
    },
    searchbar: {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        marginBottom: 24,
        marginTop: 48,

        "& button": {
            width: "100% !important"
        }
    },
    title: {
        textAlign: 'center', 
        fontWeight: 800,
        marginBottom: 0
    }
});